import {memo} from 'react';
import styles from './style.module.css';
import {Modal} from '@/components/modals';
import {Button} from '@/components/buttons';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmModal = memo(
    ({
        isOpen,
        title,
        message,
        confirmButtonText = 'Confirm',
        cancelButtonText = 'Cancel',
        onClose,
        onConfirm,
    }: ConfirmModalProps) => {
        if (!isOpen) return null;

        const modalFooter = (
            <div className={styles.modalActions}>
                <Button onClick={onClose} variant="secondary">
                    {cancelButtonText}
                </Button>
                <Button onClick={onConfirm} variant="primary">
                    {confirmButtonText}
                </Button>
            </div>
        );

        return (
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                title={title}
                footerActions={modalFooter}
                autoSize={true}
            >
                <div className={styles.modalContentText}>
                    <p>{message}</p>
                </div>
            </Modal>
        );
    }
);
